import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.iterator.js";
var render = function render() {
  var _vm$link;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.PagePersonInfo
  }, [_c('div', {
    class: [_vm.$style.textWrapper, _defineProperty({}, _vm.$style.nameHiddenOnSm, _vm.nameHiddenOnSm)]
  }, [_c('div', {
    class: _vm.$style.textWrapperLeft
  }, [_c('div', {
    class: _vm.$style.avatar
  }, [_c('SIcon', {
    attrs: {
      "icon": "i-user",
      "size": "40",
      "color": "#344F6A"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.textInner
  }, [_c('div', {
    class: _vm.$style.text
  }, [_vm._v("\n          " + _vm._s(_vm.role) + "\n        ")]), _vm._v(" "), _vm.isFullNameString ? _c('div', {
    class: [_vm.YM_HIDE_CONTENT, _vm.$style.heading]
  }, [_vm._v("\n          " + _vm._s(_vm.fullName) + "\n        ")]) : _c('NameOutput', {
    class: _vm.$style.heading,
    attrs: {
      "type": "full",
      "input": _vm.fullName
    }
  })], 1)]), _vm._v(" "), _vm.showAgent ? _c('div', {
    class: _vm.$style.linkWrapper
  }, [_c('div', {
    class: _vm.$style.agentWrapper
  }, [_c('div', {
    class: _vm.$style.text
  }, [_vm._v("\n          " + _vm._s(_vm.link.subtitle) + "\n        ")]), _vm._v(" "), _c('div', {
    class: [_vm.YM_HIDE_CONTENT, _vm.$style.textBlue]
  }, [_vm._v("\n          " + _vm._s(_vm.link.title) + "\n        ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.agencyName
  }, [_vm._v("\n          " + _vm._s(_vm.agencyName) + "\n        ")])]), _vm._v(" "), _vm.link.to ? _c('NuxtLink', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }, {
      name: "hover",
      rawName: "v-hover"
    }],
    class: _vm.$style.iconWrapper,
    attrs: {
      "to": _vm.link.to
    }
  }, [_c('SIcon', {
    class: _vm.$style.arrowDown,
    attrs: {
      "icon": "i-arrowDown",
      "size": "24"
    }
  })], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _vm.values.length ? [_c('div', {
    class: _vm.$style.divider
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.valuesWrapper
  }, [_c('div', {
    class: _vm.$style.valuesInner
  }, [(_vm$link = _vm.link) !== null && _vm$link !== void 0 && _vm$link.title ? _c('div', {
    class: [_vm.$style.row, _vm.$style.agentMobile]
  }, [_c('div', {
    class: _vm.$style.key
  }, [_vm._v("\n            " + _vm._s(_vm.link.subtitle) + "\n          ")]), _vm._v(" "), _c('div', {
    class: [_vm.YM_HIDE_CONTENT, _vm.$style.value]
  }, [_vm._v("\n            " + _vm._s(_vm.link.title) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.values, function (value) {
    return _c('div', {
      key: value.key,
      class: [_vm.$style.row, value.grow && _vm.$style.grow]
    }, [_c('div', {
      class: _vm.$style.key
    }, [_vm._v("\n            " + _vm._s(value.key) + "\n          ")]), _vm._v(" "), value.files ? _c('div', {
      class: [_vm.YM_HIDE_CONTENT, _vm.$style.files, _vm.$style.value, _vm.$style._file],
      attrs: {
        "title": value.value
      }
    }, _vm._l(value.files, function (file, idx) {
      return _c('a', {
        key: idx,
        staticClass: "link",
        attrs: {
          "href": file.aws,
          "title": file.name,
          "target": "_blank"
        }
      }, [_vm._v("\n              " + _vm._s(file.name) + "\n            ")]);
    }), 0) : _c('div', {
      class: [_vm.YM_HIDE_CONTENT, _vm.$style.value],
      attrs: {
        "title": value.value
      }
    }, [_vm._v("\n            " + _vm._s(value.value || 'Неизвестно') + "\n          ")])]);
  })], 2)])] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };